

import React from "react";
import styled from "styled-components";





export default function ShipToContainer({ shipToAddress = {} }) {
  const { firstName = "", lastName = "", addressLine1 = "", city = "City", state = "State", pinCode = "Pin Code" } = shipToAddress;


const ShipToContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
font-size: 1rem;
font-family: 'Ancizar Sans', sans-serif;

`
const ShipToTitle = styled.div`
font-size: 1.2rem;
font-weight: bold;
margin-bottom: 0.5rem;
font-family: 'Ancizar Sans', sans-serif;
font-weight: 600;

`
const ShipToDetails = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
font-size: 1rem;
font-family: 'Ancizar Sans', sans-serif;

`
const ShipTo = styled.div`
font-size: 1rem;
font-family: 'Ancizar Sans', sans-serif;
font-weight: 400;
font-weight: 500;
margin-bottom: 0.2rem;
`
console.log(shipToAddress, "shipToAddress in ShipToContainer");

  return (
    <ShipToContainer>
        <ShipToTitle>Ship To</ShipToTitle>
        <ShipToDetails>
            <ShipTo>{`${firstName} ${lastName}`}</ShipTo>
            <ShipTo>{addressLine1}</ShipTo>
            <ShipTo>{`${city}, ${state} - ${pinCode}`}</ShipTo> 
            <ShipTo>{`India`}</ShipTo>
        </ShipToDetails>

    </ShipToContainer>

  );
}